import {
  ALLOWED_MODULES_FOR_DASHBOARD_CONTRIBUTOR,
  DISABLED_MODULES,
  DISABLED_MODULES_FOR_EDITOR,
  DISABLED_MODULES_FOR_WATCHER,
  moduleNames,
} from '@va/constants';
import { modulePermissionsSlice } from '@va/dashboard/slices';
import { UserRole } from '@va/types/website';
import { isWebsiteErrorsEnabled } from '@va/util/helpers';
import { put } from 'redux-saga/effects';

export function* modulePermissionsSaga(userRole: UserRole) {
  const allModules = Object.values(moduleNames);

  const disabledModules = allModules.filter((module) => {
    return (
      isModuleDisabled(module) ||
      (userRole === UserRole.DASHBOARD && isModuleDisabledForDashboardContributor(module)) ||
      (userRole === UserRole.EDITOR && isModuleDisabledForEditor(module)) ||
      (userRole === UserRole.WATCHER && isModuleDisabledForWatcher(module))
    );
  });

  const permissions = allModules.map((module) => ({
    module,
    disabled: disabledModules.includes(module),
  }));

  yield put(modulePermissionsSlice.actions.setPermissions(permissions));
}

function isModuleDisabled(moduleName: string) {
  switch (moduleName) {
    case moduleNames.websiteErrors:
      return !(isWebsiteErrorsEnabled() || !DISABLED_MODULES.includes(moduleName));
    case moduleNames.conversions:
      return true;
    case moduleNames.conversionEvents:
    case moduleNames.conversionsSettings:
      return false;
  }
  return DISABLED_MODULES.includes(moduleName);
}

function isModuleDisabledForDashboardContributor(moduleName: string) {
  return !ALLOWED_MODULES_FOR_DASHBOARD_CONTRIBUTOR.includes(moduleName);
}

function isModuleDisabledForWatcher(moduleName: string) {
  return DISABLED_MODULES_FOR_WATCHER.includes(moduleName);
}

function isModuleDisabledForEditor(moduleName: string) {
  return DISABLED_MODULES_FOR_EDITOR.includes(moduleName);
}
